import { Navigate, useParams } from 'react-router-dom';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveICE } from '../../shared/components';
import { useGetICE } from '@/shared/actions/erp';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export type UpdateICEPageProps = {};


const UpdateICEPage: React.FC<UpdateICEPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ice)
  
  const returnUrlICEPage = ROUTER_PATHS.administration.ICENav

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetICE(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_ice) return <Navigate to={returnUrlICEPage} />;

  return <SaveICE titlePage="Editar ICE" editICE={data.data} />;
};

export default UpdateICEPage;